<template>
  <div class="stepOut">
    <div class="stepItem">
      <el-image
        class="stepItem_img"
        :src="
          stepInfo.status >= 1
            ? 'https://small.ygcha.com.cn/icon_shenqing _activate.png'
            : 'https://small.ygcha.com.cn/icon_shenqing _default.png'
        "
        alt=""
      ></el-image>
      <p :class="stepInfo.status >= 1 ? 'blue' : 'gray'">售后申请</p>
      <p class="time">{{ stepInfo.applyTime }}</p>

      <div v-if="stepInfo.status == 7" class="stepItem_xian lineAction1"></div>
      <div v-else class="stepItem_xian lineAction"></div>
      <div class="applyC" v-if="stepInfo.status == 7">申请已取消</div>
      <div class="dots" v-if="stepInfo.status == 7"></div>
      <div class="dots1" v-if="stepInfo.status == 7"></div>
    </div>
    <div class="stepItem shenheStatus">
      <el-image
        class="stepItem_img"
        :src="
          stepInfo.status !== 1 && stepInfo.status !== 7
            ? 'https://small.ygcha.com.cn/icon_shenhe _activate.png'
            : 'https://small.ygcha.com.cn/icon_shenhe _default.png'
        "
        alt=""
      ></el-image>
      <p
        :class="
          stepInfo.status !== 1 && stepInfo.status !== 7 ? 'blue' : 'gray'
        "
      >
        提交审核
      </p>
      <p class="time">{{ stepInfo.auditTime }}</p>
      <div v-if="stepInfo.status == 2" class="stepItem_xian lineAction1"></div>
      <div
        v-else
        :class="
          stepInfo.status !== 1 && stepInfo.status !== 7
            ? 'stepItem_xian lineAction'
            : 'stepItem_xian'
        "
      ></div>

      <div class="applyC" v-if="stepInfo.status == 2">申请已驳回</div>
      <div class="dots" v-if="stepInfo.status == 2"></div>
      <div class="dots1" v-if="stepInfo.status == 2"></div>
    </div>
    <!--    -->
    <div class="stepItem wuliubtn">
      <el-image
        class="stepItem_img"
        :src="
          stepInfo.status == 4 || stepInfo.status == 8
            ? 'https://small.ygcha.com.cn/icon_jihui _activate.png'
            : 'https://small.ygcha.com.cn/icon_jihui _default.png'
        "
        alt=""
      ></el-image>
      <p
        :class="stepInfo.status == 4 || stepInfo.status == 8 ? 'blue' : 'gray'"
      >
        买家寄回
      </p>
      <p class="time">{{ stepInfo.sendBackTime }}</p>
      <div
        :class="
          stepInfo.status == 4 || stepInfo.status == 8
            ? 'stepItem_xian lineAction'
            : 'stepItem_xian'
        "
      ></div>
      <div class="btn">
        <el-button
          size="mini"
          v-if="stepInfo.status == 8 || stepInfo.status == 4"
          @click="examine(1)"
          type="primary"
          plain
          >查看物流</el-button
        >
      </div>
    </div>
    <!--  -->
    <div class="stepItem">
      <el-image
        class="stepItem_img"
        :src="
          stepInfo.status == 8
            ? 'http://small.jianchiyaoye.com/icon_wancheng_activate.png'
            : 'http://small.jianchiyaoye.com/icon_wancheng_default.png'
        "
        alt=""
      ></el-image>
      <p :class="stepInfo.status == 8 ? 'blue' : 'gray'">售后完成</p>
      <p class="time">{{ stepInfo.completeTime }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'steps',
  props: {
    // 传递步骤参数
    stepInfo: {
      type: Object,
      default: function () {
        return {
          list: []
        }
      }
    },
    afterType: {
      type: Number,
      default: null
    },
    status: {
      type: Object,
      default: function () {
        return {
          list: []
        }
      }

    }
  },
  methods: {
    stepBtn (type) {
      this.$emit('stepStatus', type)
    },
    examine (val) {
      this.$parent.examine(val)
    }
  }

}
</script>

<style lang="scss" scoped>
.stepOut {
  display: flex;
  justify-content: center;

  .show {
    display: block;
  }
  .hide {
    display: none;
  }
  .stepItem {
    width: 30%;
    height: 140px;
    text-align: center;
    position: relative;
    padding-top: 15px;
    box-sizing: border-box;
    .stepItem_img {
      width: 56px;
      height: 56px;
    }
    .stepItem_xian {
      position: absolute;
      left: 74%;
      top: 54px;
      width: 50%;
      height: 0px;
      border: 2px dashed #cccccc;
    }
    .lineAction {
      border: 2px dashed #4c81eb;
    }
    .lineAction1 {
      border: 2px dashed #f33f3f;
    }
    .applyC {
      position: absolute;
      left: 93.5%;
      top: 32px;
      width: 70px;
      height: 20px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 2px;
      color: #f33f3f;
      opacity: 1;
    }
    .dots1 {
      width: 14px;
      height: 14px;
      background: #f33f3f;
      border-radius: 50%;
      opacity: 0.2;
      position: absolute;
      left: 99.3%;
      top: 48.5px;
    }
    .dots {
      width: 8px;
      height: 8px;
      background: #f33f3f;
      border-radius: 50%;
      opacity: 1;
      position: absolute;
      left: 100%;
      top: 52px;
    }
    .blue {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
    }
    .gray {
      font-size: 14px;
      font-weight: 400;
      color: #cccccc;
    }
    .time {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
    }
  }
  .wuliubtn {
    position: relative;
    .btn {
      position: absolute;
      left: 87%;
      top: 65px;
      z-index: 9999;
    }
  }
  .shenheStatus {
    position: relative;
    .close {
      position: absolute;
      left: 74%;
      top: 54px;
      width: 50%;
      height: 0px;
      border: 1px dashed red;
      &:before {
        width: 8px;
        height: 8px;
        background: red;
        border-radius: 50%;
        content: "";
        color: red;
        position: absolute;
        border: 3px solid #f5d3d9;
        left: 46%;
        top: -7px;
      }
      &:after {
        width: 100px;
        content: "售后关闭/拒绝";
        color: red;
        position: absolute;
        left: 17%;
        top: -39px;
        font-size: 14px;
        font-weight: bold;
      }
    }
    .closeTwo {
      position: absolute;
      left: 74%;
      top: 54px;
      width: 50%;
      height: 0px;
      border: 1px dashed red;
      &:before {
        width: 8px;
        height: 8px;
        background: red;
        border-radius: 50%;
        content: "";
        color: red;
        position: absolute;
        border: 3px solid #f5d3d9;
        left: 46%;
        top: -7px;
      }
      &:after {
        width: 100px;
        content: "售后关闭/拒绝";
        color: red;
        position: absolute;
        left: 16%;
        top: -39px;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .stepItem_img {
    width: 48px !important;
    height: 48px !important;
  }
  .close {
    position: absolute;
    left: 74%;
    top: 54px;
    width: 50%;
    height: 0px;
    border: 1px dashed red;
    &:before {
      width: 8px;
      height: 8px;
      background: red;
      border-radius: 50%;
      content: "";
      color: red;
      position: absolute;
      border: 3px solid #f5d3d9;
      left: 46%;
      top: -7px;
    }
    &:after {
      width: 100px;
      content: "售后关闭/拒绝";
      color: red;
      position: absolute;
      left: -3% !important;
      top: -39px;
      font-size: 14px;
      font-weight: bold;
    }
  }
  .closeTwo {
    position: absolute;
    left: 74%;
    top: 54px;
    width: 50%;
    height: 0px;
    border: 1px dashed red;
    &:before {
      width: 8px;
      height: 8px;
      background: red;
      border-radius: 50%;
      content: "";
      color: red;
      position: absolute;
      border: 3px solid #f5d3d9;
      left: 46%;
      top: -7px;
    }
    &:after {
      width: 100px;
      content: "售后关闭/拒绝";
      color: red;
      position: absolute;
      left: -3% !important;
      top: -39px;
      font-size: 14px;
      font-weight: bold;
    }
  }
  .wuliubtn {
    position: relative;
    .btn {
      position: absolute;
      left: 73% !important;
      top: 65px;
      z-index: 9999;
    }
  }
}
</style>
